export default function extEStCalcSZ(einkommen) {
  const klassen = [
    { min: 0, max: 620, satz: 0 },
    { min: 620.01, max: 25000, satz: 0.06 },
    { min: 25000.01, max: 50000, satz: 0.27 },
    { min: 50000.01, max: 83333, satz: 0.3575 },
    { min: 83333.01, max: 142857, satz: 0.5 },
    { min: 142857.01, max: Infinity, satz: 0.55 },
  ];
  console.log("einkommenSteuerBerechnen");
  let berechneteSteuer = 0;

  for (let i = 0; i < klassen.length; i++) {
    const klasse = klassen[i];

    if (einkommen >= klasse.min) {
      const zuVersteuernderBetrag = Math.min(
        einkommen - klasse.min,
        klasse.max - klasse.min
      );
      berechneteSteuer += zuVersteuernderBetrag * klasse.satz;
    }
  }

  return berechneteSteuer;
}
